import { mapGetters } from "vuex";

export default {
    props: {
        sectionId: String,
        cardId: String
      },
      methods: {
        cardsBySectionId(id) {
          return this.decisionBranches.cards
            .filter((item) => item.section == id)
            .sort((a, b) => a.ehOrder - b.ehOrder);
        },
        addSubSectionIfSubSectionNameExists(subSections, subSectionName, subSectionResources){
          if(subSectionName){
            subSections.push({name:subSectionName, resources:subSectionResources});
          }
          return subSections;
        }
      },
      computed: {
        ...mapGetters(["decisionBranches"]),
        currentSection() {
          return this.decisionBranches.sections.filter(
            (item) => item.id == this.sectionId
          )[0];
        },
        currentCard() {
          return this.decisionBranches.cards.filter(
            (item) => item.id == this.cardId
          )[0];
        },
        currentSubSections(){
          let subSections = [];
          let currentSection = this.currentSection;
          subSections = this.addSubSectionIfSubSectionNameExists(subSections, currentSection.subSection1Name, currentSection.subSection1Resources);
          subSections = this.addSubSectionIfSubSectionNameExists(subSections, currentSection.subSection2Name, currentSection.subSection2Resources);
          subSections = this.addSubSectionIfSubSectionNameExists(subSections, currentSection.subSection3Name, currentSection.subSection3Resources);

          return subSections;
        }
      }
}